import React, { ReactElement, useState, useEffect, useRef } from "react";

import { AxiosResponse } from "axios";

import { QuestionType } from "../../../types";

import { getHourAndMintFromFBTimeStamp } from "../../../utils/helpers";

import { useTranslation } from "react-i18next";

import apiRequest from "../../../apis/request";

import { useSelector, shallowEqual } from "react-redux";

type QuestionResponseType = AxiosResponse & { data: QuestionType };

const Question = ({ questions, sessionId, sessionDetails }): ReactElement => {
  const [loading, setIsLoading] = useState(false);
  const [response, setIsResponse] = useState(false);
  const [questionText, setQuestionText] = useState("");

  const { loggedInUser: userInfo, track } = useSelector(
    ({ track, loggedInUser }) => ({ track, loggedInUser }),
    shallowEqual
  );

  const qnaListRef = useRef<any>();

  const { t } = useTranslation();

  const scrollToEnd = () => {
    // qnaListRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    setTimeout(() => {
      qnaListRef.current.scrollTop = qnaListRef.current.scrollHeight;
    }, 200);
  };

  const handleSubmit = async () => {
    if (questionText.trim() === "") return;
    setIsLoading(true);

    const payload: QuestionType = {
      q: questionText,
      isVisible: sessionDetails.qnaModeration === "passive",
      displayName: userInfo?.displayName || "",
    };
    try {
      const resp = await apiRequest("POST", "/question", [], {
        trackId: track.docId,
        sessionId,
        question: payload,
      });

      if (resp.status === 200) {
        if (sessionDetails.qnaModeration === "active") {
          setIsResponse(true);
        }

        scrollToEnd();

        setQuestionText("");
      }
      setIsLoading(false);
    } catch (e) {
      console.log("Couldn't save question", e);
    }
  };

  const handleEdit = () => {
    setIsLoading(false);
    setIsResponse(false);
  };

  return (
    <div className="tm__polls-question">
      <div className="tm__polls">
        {/* Loader - Start */}
        {loading && (
          <div className="tm__polls-loader d-flex justify-content-center align-items-center">
            <div className="spinner-border text-primary" role="status"></div>
          </div>
        )}
        {/* Loader - End */}

        {!response && (
          <div className="tm__polls-head tm__polls-head-divider">
            <label className="fs-7 text-primary mb-0">
              {t("TEXT_SUBMIT_OK")}
            </label>
          </div>
        )}

        <div className="tm__polls-body">
          {/* Question - Start */}
          {/* {JSON.stringify(sessionDetails)} */}
          <div className="d-flex flex-column">
            {sessionDetails?.qnaModeration !== "passive" && (
              <p className="fs-8">{t("POLLS_QnA_DESCRIPTION")}</p>
            )}
            {!response && (
              <div className="d-flex align-items-center">
                <textarea
                  className="form-control mt-2 h-50"
                  placeholder={t("QNA_ASK_QUESTION")}
                  style={{ color: "white" }}
                  value={questionText}
                  onKeyDown={(e) => {
                    // console.log(e.key);
                    if (e.key === "Enter") {
                      handleSubmit();
                    }
                  }}
                  onChange={(e) => setQuestionText(e.target.value)}></textarea>
                <button
                  type="button"
                  className="btn-icon btn-icon-primary rounded-circle ms-2"
                  onClick={() => {
                    handleSubmit();
                  }}>
                  <i className="bi bi-arrow-right-short"></i>
                </button>
              </div>
            )}
          </div>

          {/* Question - End */}
        </div>

        {response && sessionDetails?.qnaModeration === "active" && (
          <div className="tm__polls-body">
            {/* Response - Start */}
            <div className="d-flex flex-column align-items-center">
              <i className="bi bi-exclamation-circle-fill text-primary fs-1"></i>
              <span>{t("QNA_MODERATION_WARNING")}</span>
            </div>
            {/* Response - End */}
          </div>
        )}

        {response && sessionDetails.qnaModeration === "active" && (
          <div className="tm__polls-footer tm__polls-footer-divider d-flex justify-content-center">
            <button
              type="button"
              className="btn btn-primary btn-small"
              onClick={() => {
                handleEdit();
              }}>
              {t("TEXT_SUBMIT_OK")}
            </button>
          </div>
        )}
      </div>

      <div className="tm__question-list" ref={qnaListRef}>
        {sessionDetails.qnaModeration !== "passive" && (
          <span className="alert alert-primary internal-message fs-9 p-2 mb-2">
            {t("QNA_MODERATION_INFO")}
          </span>
        )}

        {!!questions?.length &&
          questions
            .filter((d) => d.isVisible || d.uid === userInfo.uid)
            .map((d) => (
              <div
                className={`tm__polls ${!d.isVisible ? "opacity-50" : ""}`}
                key={d.docId}>
                <div className="tm__polls-body d-flex">
                  <div className="d-flex flex-column w-100">
                    <label className="fs-7 m-0 lh-sm text-primary mb-2">
                      {d.q}
                    </label>
                    <div className="d-flex justify-content-between align-items-center lh-sm">
                      <div className="d-flex align-items-center">
                        <i className="bi bi-person-fill fs-9 me-1"></i>
                        <small className="fs-9 lh-sm">{d.displayName}</small>
                      </div>
                      <div className="d-flex align-items-center">
                        <i className="bi bi-clock-fill fs-9 me-1"></i>
                        <small className="fs-9 lh-sm">
                          {getHourAndMintFromFBTimeStamp(d?.createdAt?.seconds)}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        {/* <div className="tm__polls"></div> */}
      </div>
    </div>
  );
};

export default Question;
